import * as React from 'react';
import { get } from 'lodash';
import bind from '@reverbdotcom/commons/dist/bind';
import { mountComponent } from '../adyen_checkout_mounter';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';

export interface IExternalProps {
  challengeToken: string;
  onComplete: (challengeResult: string) => void;
  onError: (error: Error) => void;
}

export type IProps = IExternalProps & IUserContext;

const CHALLENGE_SHOPPER_CONTAINER_ID = 'challenge-shopper';

export class ChallengeShopper extends React.Component<IProps, null> {
  @bind
  onComplete(result) {
    const challengeResult = get(result, ['data', 'details', 'threeds2.challengeResult']);
    this.props.onComplete(challengeResult);
  }

  componentDidMount() {
    mountComponent({
      domSelector: `#${CHALLENGE_SHOPPER_CONTAINER_ID}`,
      type: 'threeDS2Challenge',
      locale: this.props.user.locale,
      props: {
        challengeToken: this.props.challengeToken,
        onComplete: this.onComplete,
        onError: this.props.onError,
        // size could be based on window dimensions,
        // '05' is 100% width 100% height of the container div
        size: '05',
      },
    });
  }

  render() {
    return (
      <div id={CHALLENGE_SHOPPER_CONTAINER_ID} />
    );
  }
}

export default withUserContext(ChallengeShopper);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/threeds2/challenge_shopper.tsx